// extracted by mini-css-extract-plugin
module.exports = {"bylineWithHeadshots":"styles-module__bylineWithHeadshots___73phU"};